import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import ImgSeminario from './assets/BannerSeminario.svg';
import IASLogo from './assets/IAS_Logo.svg';
import ReguaLogo from './assets/Regua_nova.png';
import Colors from 'enums/Colors';
import { RiShareBoxLine } from 'react-icons/ri';
import { Modal } from 'react-bootstrap';
import { Checkbox, DatePicker, Divider, Input, notification } from 'antd';
import { ButtonHomeV2 } from 'pages/home/components/homeV2/button/ButtonHomeV2.styled';
import AlfabetizacaoSeminario from 'models/alfabetizacao/AlfabetizacaoSeminario';
import useFetch from 'hooks/useFetch';
import axios from 'axios';
import dayjs from 'dayjs';
import { ValidadeHelp } from 'core/util/ValidateHelp';
import { NotificationInstance } from 'antd/es/notification/interface';
import AlfabetizacaoSeminarioService from 'core/http/service/alfabetizacao/AlfabetizacaoSeminario.service';
import { ValidateEmail } from 'core/util/ValidationsHelp';
import { useAppSelector } from 'hooks/LocalReduxThunk';
import ModalPlayListVideos, { ListPlayVideosForModal } from './ModalPlaylistVideos';
import { useHistory } from 'react-router-dom';

const Styled = {
    Container: styled.div`
        position: relative;
        display: flex;
        justify-content: center;
        background-color: #f9f9f9;
        height: 720px;
        flex-direction: column;

        @media screen and (max-width: 780px) {
            height: 900px;
        }
        @media screen and (max-width: 590px) {
            height: 980px;
        }

        @media screen and (max-width: 410px) {
            height: 1100px;
        }
    `,

    Content: styled.div`
        width: 100%;
        position: relative;
        height: 100%;
        overflow: hidden;
    `,

    Button: styled.button`
        width: 235px;
        height: 54px;
        border-radius: 4px;
        padding-top: 10px;
        padding-right: 20px;
        padding-bottom: 10px;
        padding-left: 20px;
        gap: 10px;
        border: none;
        background-color: ${Colors.Yellow};
        color: ${Colors.Blue};
    `,

    Img: styled.img`
        width: 100%;
        height: 100%;
        object-fit: cover;
        z-index: 0;

        @media screen and (max-width: 1000px) {
            object-position: calc(80%);
        }
    `,

    ImgLogo: styled.img`
        top: 30px;
        left: 280px;
        position: absolute;

        @media screen and (max-width: 1600px) {
            left: 80px;
        }
        @media screen and (max-width: 540px) {
            left: 80px;
        }
        @media screen and (max-width: 500px) {
            left: 20px;
        }
    `,

    Paragrafo: styled.p`
        font-family: 'Barlow';
        font-weight: 400;
        font-size: 16px;
        line-height: 150%;
        letter-spacing: -1%;
        vertical-align: middle;
        max-width: 707px;
        color: ${Colors.White};

        @media screen and (max-width: 780px) {
            max-width: 500px;
        }
    `,
    Paragrafo2: styled.p`
        font-family: 'Barlow';
        font-weight: 400;
        font-size: 25.49px;
        line-height: 150%;
        letter-spacing: -1%;
        vertical-align: middle;

        color: ${Colors.White};

        @media screen and (max-width: 780px) {
            max-width: 500px;
        }
    `,

    SubTitle: styled.h2`
        font-family: 'Barlow';
        font-weight: 700;
        font-size: 40.09px;
        line-height: 100%;
        letter-spacing: -1%;
        vertical-align: middle;
        text-transform: uppercase;
        color: ${Colors.Yellow};
    `,

    Title: styled.h1`
        font-family: 'Barlow';
        font-weight: 700;
        font-size: 46.74px;
        line-height: 100%;
        letter-spacing: -1%;
        vertical-align: middle;
        color: ${Colors.White};
    `,

    Body: styled.div`
        position: absolute;
        padding-top: 40px;
        top: 0;
        width: 100%;
        z-index: 10;
        left: 280px;
        display: flex;
        flex-direction: column;
        gap: 24px;

        @media screen and (max-width: 1600px) {
            left: 80px;
        }
        @media screen and (max-width: 760px) {
            left: 20px;
            padding-right: 22px;
        }
    `,

    ReguaLogo: styled.img`
        display: block;
        position: absolute;
        z-index: 10;
        bottom: 20px;
        left: 280px;
        width: 665px;
        max-width: calc(100vw - 560px);
        height: auto;
        object-fit: contain;

        @media screen and (max-width: 1600px) {
            left: 80px;
        }

        @media screen and (max-width: 750px) {
            left: 0;
            width: 100%;
            max-width: none;
            bottom: 0;
        }
    `,

    Modal: {
        Content: styled.div`
            display: flex;
            flex-direction: column;
            gap: 1rem;
        `,

        Fields: styled.div`
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
        `,

        GridForm: styled.div`
            display: grid;
            width: 100%;

            grid-template-columns: repeat(2, 1fr);
            gap: 1rem;

            @media screen and (max-width: 460px) {
                grid-template-columns: repeat(1, 1fr);
            }
        `,

        Title: styled.h1`
            font-size: 26px;
            font-weight: 700;
            color: ${Colors.Blue};
        `,

        Description: styled.p`
            font-size: 18px;
            line-height: 24px;
        `,
    },
};

interface IModalSeminario {
    open: boolean;
    setOpen: (value: boolean) => void;
    indexPage: number;
    setIndexPage: (value: number) => void;
    api: NotificationInstance;
}

interface FormValues {
    name: string;
    email: string;
    phone: string;
    cpf: string;
    rg: string;
    dateBirth: string;
    address: {
        cep: string;
        logradouro: string;
        numero: string;
        bairro: string;
        cidade: string;
        estado: string;
        complemento: string;
    };
    termDadosUse: boolean;
    termParticipatedFree: boolean;
    codigo: number;
}

const initialValues: FormValues = {
    name: '',
    email: '',
    phone: '',
    cpf: '',
    rg: '',
    dateBirth: '',
    address: {
        cep: '',
        logradouro: '',
        numero: '',
        bairro: '',
        cidade: '',
        estado: '',
        complemento: '',
    },
    termDadosUse: false,
    termParticipatedFree: false,
    codigo: -1,
};

type NotificationType = 'success' | 'info' | 'warning' | 'error';

const serviceAlfabetizacao = new AlfabetizacaoSeminarioService();

const ModalSeminario: React.FC<IModalSeminario> = ({ open, setOpen, indexPage, setIndexPage, api }) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [form, setForm] = useState<FormValues>(initialValues);
    const [indexFildsErr, setIndexFieldsErr] = useState<number[]>([]);
    const isLoggedin: Boolean = useAppSelector(state => state.profileReducer.isLoggedin);

    const handleValue = (index: keyof FormValues, value: string | boolean) => {
        setForm(prev => ({
            ...prev,
            [index]: value,
        }));
    };

    const openNotificationWithIcon = (type: NotificationType, title: string, desc: string) => {
        api[type]({
            message: title,
            description: desc,
        });
    };

    const handleAddressValue = (index: keyof FormValues['address'], value: string) => {
        setForm(prev => ({
            ...prev,
            address: {
                ...prev.address,
                [index]: value,
            },
        }));
    };

    const handleValidateCPF = async (AccessPage: boolean) => {
        try {
            if (!AccessPage && !ValidadeHelp.validarCPF(form.cpf)) {
                return openNotificationWithIcon('error', 'CPF Inválido', 'O CPF digitado é inválido. Por favor, corrija e tente novamente.');
            }

            form.cpf = AccessPage ? '-1' : form.cpf.replace(/[^\d]/g, '');

            const { data, status } = await serviceAlfabetizacao.validation(form.cpf ?? '');

            if (status !== 200) {
                return openNotificationWithIcon(
                    'error',
                    'Não foi possível validar!',
                    'Servidor está com instabilidade. Tente novamente mais tarde ou entre em contato.'
                );
            }

            return setIndexPage(data ? 4 : 2);
        } catch (error: any) {
            console.error('Erro na validação do CPF:', error);

            // Se estiver usando axios, você pode fazer:
            if (axios.isAxiosError(error)) {
                const status = error.response?.status;
                // Trate por status, se necessário
            }
        }
    };

    const validationForm = (): boolean => {
        setIndexFieldsErr([]);

        let validated = true;

        if (form.name.trim().length < 10) {
            setIndexFieldsErr((prev: number[]) => {
                return [...prev, 1];
            });
            validated = false;
        }

        if (form.email.trim().length < 10 || !ValidateEmail(form.email)) {
            setIndexFieldsErr((prev: number[]) => {
                return [...prev, 2];
            });
            validated = false;
        }

        if (form.cpf.trim().length < 11 || !ValidadeHelp.validarCPF(form.cpf)) {
            setIndexFieldsErr((prev: number[]) => {
                return [...prev, 3];
            });
            validated = false;
        }

        if (form.rg.trim().length < 10) {
            setIndexFieldsErr((prev: number[]) => {
                return [...prev, 4];
            });
            validated = false;
        }

        if (form.phone.trim().length < 11) {
            setIndexFieldsErr((prev: number[]) => {
                return [...prev, 5];
            });
            validated = false;
        }

        if (form.dateBirth.trim().length === 0) {
            setIndexFieldsErr((prev: number[]) => {
                return [...prev, 6];
            });
            validated = false;
        }

        if (
            form.address.cep.trim().length < 7 ||
            form.address.bairro.trim().length < 1 ||
            form.address.numero.trim().length === 0 ||
            form.address.complemento.trim().length < 4
        ) {
            setIndexFieldsErr((prev: number[]) => {
                return [...prev, 7];
            });
            validated = false;
        }

        if (!form.termDadosUse) {
            setIndexFieldsErr((prev: number[]) => {
                return [...prev, 8];
            });
            validated = false;
        }

        if (!form.termParticipatedFree) {
            setIndexFieldsErr((prev: number[]) => {
                return [...prev, 9];
            });
            validated = false;
        }

        return validated;
    };

    const handleSaveForm = async () => {
        setLoading(true);
        try {
            const body = AlfabetizacaoSeminario.fromJSON(form);
            body.dateBirth = body.dateBirth ? new Date(body.dateBirth).toISOString().split('T')[0] : '';

            if (validationForm()) {
                const { status } = await serviceAlfabetizacao.create(body);

                if (status === 201) {
                    setIndexPage(3);
                    openNotificationWithIcon('success', 'Informações salvas!', 'Suas informações foram salvas com sucesso!');
                }
            } else {
                openNotificationWithIcon(
                    'error',
                    'Informações inválidas!',
                    'Faça a correção dos campos do formulário para conseguir prosseguir.'
                );
            }
        } catch (error) {
            openNotificationWithIcon(
                'error',
                'Servidor com instabilidade!',
                'Por favor, tente novamente mais tarde, caso venha ocorrer novamente o problema entre em contato.'
            );
        } finally {
            setLoading(false);
        }
    };

    useFetch(async () => {
        if (form.address.cep.trim().length > 7) {
            const { data, status } = await axios(`https://viacep.com.br/ws/${form.address.cep}/json/`);

            if (status === 200) {
                const response = data;

                handleAddressValue('logradouro', response.logradouro);
                handleAddressValue('bairro', response.bairro);
                handleAddressValue('estado', response.estado);
                handleAddressValue('cidade', response.localidade);
            }
        } else if (form.address.cep.trim().length < 7 && form.address.bairro.trim().length > 0) {
            setForm(prev => ({ ...prev, address: initialValues.address }));
        }
    }, [form.address.cep]);

    useFetch(async () => {
        if (isLoggedin && indexPage !== 4) {
            await handleValidateCPF(true);
        }
    }, [isLoggedin, indexPage]);

    return (
        <React.Fragment>
            <Modal show={open} centered size="lg" onHide={() => setOpen(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Seminário Alfabetização 360</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {indexPage === 1 ? (
                        <>
                            <Styled.Modal.Content>
                                <h1>Digite seu CPF:</h1>
                                <Input
                                    onError={() => ''}
                                    size="large"
                                    placeholder="Digite seu CPF"
                                    value={form.cpf}
                                    onChange={e => handleValue('cpf', e.target.value)}
                                />
                                <ButtonHomeV2 disabled={loading} onClick={() => handleValidateCPF(false)}>
                                    Acessar conteúdos
                                </ButtonHomeV2>
                            </Styled.Modal.Content>
                        </>
                    ) : indexPage === 2 ? (
                        <>
                            <Styled.Modal.Content>
                                <p>
                                    Percebemos que você ainda não realizou preencheu o formulário para o acesso aos conteúdos, faça o
                                    preenchimento abaixo para prosseguir.
                                </p>
                                <Divider />
                                <Styled.Modal.GridForm>
                                    <Styled.Modal.Fields>
                                        <h1>Digite seu nome completo:*</h1>
                                        <Input
                                            status={[1].some(i => indexFildsErr.includes(i)) ? 'error' : ''}
                                            size="large"
                                            placeholder="Digite seu nome completo"
                                            value={form.name}
                                            onChange={e => handleValue('name', e.target.value)}
                                            count={{
                                                show: true,
                                                max: 100,
                                            }}
                                        />
                                    </Styled.Modal.Fields>
                                    <Styled.Modal.Fields>
                                        <h1>Digite seu e-mail:*</h1>
                                        <Input
                                            status={[2].some(i => indexFildsErr.includes(i)) ? 'error' : ''}
                                            size="large"
                                            placeholder="Digite seu e-mail"
                                            value={form.email}
                                            onChange={e => handleValue('email', e.target.value)}
                                            count={{
                                                show: true,
                                                max: 100,
                                            }}
                                        />
                                    </Styled.Modal.Fields>
                                    <Styled.Modal.Fields>
                                        <h1>Digite seu CPF:*</h1>
                                        <Input
                                            status={[3].some(i => indexFildsErr.includes(i)) ? 'error' : ''}
                                            size="large"
                                            placeholder="Digite seu CPF"
                                            value={form.cpf}
                                            onChange={e => handleValue('cpf', e.target.value)}
                                            count={{
                                                show: true,
                                                max: 20,
                                            }}
                                        />
                                    </Styled.Modal.Fields>
                                    <Styled.Modal.Fields>
                                        <h1>Digite seu RG:*</h1>
                                        <Input
                                            status={[4].some(i => indexFildsErr.includes(i)) ? 'error' : ''}
                                            size="large"
                                            placeholder="Digite seu RG"
                                            value={form.rg}
                                            onChange={e => handleValue('rg', e.target.value)}
                                            count={{
                                                show: true,
                                                max: 20,
                                            }}
                                        />
                                    </Styled.Modal.Fields>
                                    <Styled.Modal.Fields>
                                        <h1>Digite seu telefone:*</h1>
                                        <Input
                                            status={[5].some(i => indexFildsErr.includes(i)) ? 'error' : ''}
                                            size="large"
                                            placeholder="Digite seu Telefone"
                                            value={form.phone}
                                            onChange={e => handleValue('phone', e.target.value)}
                                            count={{
                                                show: true,
                                                max: 11,
                                            }}
                                        />
                                    </Styled.Modal.Fields>
                                    <Styled.Modal.Fields>
                                        <h1>Digite a sua data de nascimento:*</h1>
                                        <DatePicker
                                            status={[6].some(i => indexFildsErr.includes(i)) ? 'error' : ''}
                                            size="large"
                                            value={dayjs(form.dateBirth?.length > 0 ? form.dateBirth : '01/01/1970')}
                                            format={'DD/MM/YYYY'}
                                            onChange={e => handleValue('dateBirth', e?.toDate().toString())}
                                            placeholder="Digite sua data de nascimento"
                                        />
                                    </Styled.Modal.Fields>
                                    <React.Fragment>{'Endereço:'}</React.Fragment>
                                    <Divider />
                                    <Styled.Modal.Fields>
                                        <h1>CEP:*</h1>
                                        <Input
                                            status={[7].some(i => indexFildsErr.includes(i)) ? 'error' : ''}
                                            size="large"
                                            placeholder="Digite o CEP"
                                            value={form.address.cep}
                                            onChange={e => handleAddressValue('cep', e.target.value)}
                                            count={{
                                                show: true,
                                                max: 8,
                                            }}
                                        />
                                    </Styled.Modal.Fields>
                                    <Styled.Modal.Fields>
                                        <h1>Logradouro:</h1>
                                        <Input
                                            status={[7].some(i => indexFildsErr.includes(i)) ? 'error' : ''}
                                            size="large"
                                            readOnly
                                            placeholder="Logradouro"
                                            value={form.address.logradouro}
                                        />
                                    </Styled.Modal.Fields>
                                    <Styled.Modal.Fields>
                                        <h1>Número:*</h1>
                                        <Input
                                            status={[7].some(i => indexFildsErr.includes(i)) ? 'error' : ''}
                                            size="large"
                                            placeholder="Digite o número"
                                            value={form.address.numero}
                                            onChange={e => handleAddressValue('numero', e.target.value)}
                                            count={{
                                                show: true,
                                                max: 10,
                                            }}
                                        />
                                    </Styled.Modal.Fields>
                                    <Styled.Modal.Fields>
                                        <h1>Complemento:*</h1>
                                        <Input
                                            status={[7].some(i => indexFildsErr.includes(i)) ? 'error' : ''}
                                            size="large"
                                            placeholder="Digite o complemento"
                                            value={form.address.complemento}
                                            onChange={e => handleAddressValue('complemento', e.target.value)}
                                            count={{
                                                show: true,
                                                max: 50,
                                            }}
                                        />
                                    </Styled.Modal.Fields>
                                    <Styled.Modal.Fields>
                                        <h1>Bairro:</h1>
                                        <Input
                                            status={[7].some(i => indexFildsErr.includes(i)) ? 'error' : ''}
                                            size="large"
                                            readOnly
                                            placeholder="Bairro"
                                            value={form.address.bairro}
                                        />
                                    </Styled.Modal.Fields>
                                    <Styled.Modal.Fields>
                                        <h1>Estado:</h1>
                                        <Input
                                            status={[7].some(i => indexFildsErr.includes(i)) ? 'error' : ''}
                                            size="large"
                                            readOnly
                                            placeholder="Estado"
                                            value={form.address.estado}
                                        />
                                    </Styled.Modal.Fields>
                                    <Styled.Modal.Fields>
                                        <h1>Cidade:</h1>
                                        <Input
                                            status={[7].some(i => indexFildsErr.includes(i)) ? 'error' : ''}
                                            size="large"
                                            readOnly
                                            placeholder="Cidade"
                                            value={form.address.cidade}
                                        />
                                    </Styled.Modal.Fields>
                                </Styled.Modal.GridForm>
                                <Checkbox required onChange={e => handleValue('termParticipatedFree', e.target.checked)}>
                                    Li e estou de acordo com o{' '}
                                    <a
                                        href="#"
                                        onClick={() =>
                                            window.open(
                                                'https://institutoas-my.sharepoint.com/:w:/g/personal/arquivosias_ias_org_br/ESWBDYsYctVFqdIbnbIPs64ByYYoM6LG1bd16ujcZnlgQQ?e=Z9T5SY'
                                            )
                                        }
                                    >
                                        Termo de Participação Gratuita
                                    </a>{' '}
                                </Checkbox>
                                <Checkbox required onChange={e => handleValue('termDadosUse', e.target.checked)}>
                                    Li e estou de acordo com o{' '}
                                    <a
                                        href="#"
                                        onClick={() =>
                                            window.open(
                                                'https://institutoas-my.sharepoint.com/:w:/g/personal/arquivosias_ias_org_br/ETQiF6uCeURDmXghKZnwYIMBJmt81O8PRoXV_V5kClgjog?e=oycnPu'
                                            )
                                        }
                                    >
                                        Termo de Uso de Dados Pessoais
                                    </a>{' '}
                                </Checkbox>
                                <ButtonHomeV2 disabled={loading} onClick={handleSaveForm}>
                                    Salvar
                                </ButtonHomeV2>
                            </Styled.Modal.Content>
                        </>
                    ) : indexPage === 3 ? (
                        <>
                            <Styled.Modal.Content>
                                <Styled.Modal.Title>CONTEÚDO PROGRAMÁTICO</Styled.Modal.Title>
                                <Styled.Modal.Description
                                    dangerouslySetInnerHTML={{
                                        __html: `
                1. Políticas Públicas voltadas à Alfabetização - Estratégias de implementação de políticas públicas eficazes e equitativas.<br/><br/>
                2. Desenvolvimento Integral dos Alunos: <br/>
                - Integração de competências socioemocionais no processo de alfabetização.<br/><br/>
                3. Gestão Eficiente da Alfabetização:<br/>
                - Planejamento e organização de programas de alfabetização.<br/>
                - Monitoramento e avaliação do progresso dos alunos.<br/>
                - Formação de professores e capacitação de equipe pedagógica.<br/>
                - Indicadores de avaliação da qualidade da alfabetização.<br/>
                - Uso de dados para tomada de decisões e melhoria contínua<br/>
                -Inclusão e diversidade na alfabetização.<br/><br/>
                4. Recomposição de aprendizagens e alfabetização <br/><br/>
                5. Neurociência e Alfabetização:<br/>
                - Implicações práticas das descobertas recentes da neurociência para o ensino da alfabetização.<br/>
                - Uso de métodos baseados em evidências na alfabetização.<br/><br/>
                6. Experiências bem-sucedidas de municípios e estados na promoção da alfabetização.<br/>
                - Cases de sucesso e Boas Práticas

                
                `,
                                    }}
                                />
                                <ButtonHomeV2 onClick={() => setIndexPage(4)}>Acessar conteúdos</ButtonHomeV2>
                            </Styled.Modal.Content>
                        </>
                    ) : (
                        <div style={{ height: '500px' }}>
                            <iframe
                                src="https://www.youtube.com/embed/G9g_EhcLEfA"
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                }}
                            ></iframe>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        </React.Fragment>
    );
};

const Seminario360 = () => {
    const history = useHistory();

    const [api, contextHolder] = notification.useNotification();

    const goToLink = () => {
        history.push(`/playlist-videos/seminario/OQJSoeAVwPw`);
        window.location.reload();
    };

    return (
        <Styled.Container>
            {contextHolder}
            {/* <ModalSeminario open={open} setOpen={setOpen} indexPage={indexModal} setIndexPage={setIndexModal} api={api} /> */}
            {/* <ModalPlayListVideos open={open} setOpen={setOpen} listVideos={List} /> */}
            <Styled.Content>
                {/* <Styled.ImgLogo src={IASLogo} alt="" /> */}
                <Styled.Body>
                    <Styled.Paragrafo
                        style={{ textTransform: 'uppercase', fontSize: '14px' }}
                        dangerouslySetInnerHTML={{
                            __html: `
                    Ministério da Cultura, Instituto Ayrton Senna, Guaraná Antarctica <br/> e Start By Alura apresentam o projeto Alfabetização Integral <br/>
                    em Apoio ao Compromisso Nacional Criança Alfabetizada.
                    
                    `,
                        }}
                    />
                    <div style={{ marginTop: '0px' }}>
                        <Styled.Title>Seminário Alfabetização 360</Styled.Title>
                        <Styled.Paragrafo2>Políticas e Práticas para uma Alfabetização Integral</Styled.Paragrafo2>
                    </div>
                    <Styled.Paragrafo
                        dangerouslySetInnerHTML={{
                            __html: `
                           A alfabetização é a chave para transformar vidas e essencial para o incentivo à cultura, mas como garantir que todas as crianças tenham acesso à aprendizagem significativa, 
                           respeitando suas singularidades? Como formar professores leitores e alfabetizadores engajados? Como a neurociência pode contribuir para essa jornada? 
                            <br/><br/>
                            O seminário reuniu especialistas, pesquisadores, gestores educacionais e o público em geral para debater e responder essas e outras questões.
                            
                            `,
                        }}
                    />
                    <Styled.Paragrafo2 style={{ fontSize: '20px', fontWeight: 'bold' }}>
                        Curioso(a)? Agora você tem a oportunidade de <br /> acessar os vídeos do seminário.
                    </Styled.Paragrafo2>
                    <Styled.Button onClick={() => goToLink()}>
                        Acessar <RiShareBoxLine />
                    </Styled.Button>
                </Styled.Body>

                <Styled.ReguaLogo src={ReguaLogo} />
                <Styled.Img src={ImgSeminario} alt="" />
            </Styled.Content>
        </Styled.Container>
    );
};

export default Seminario360;
